import "@frog/source/index.less"

////////////
// Frame //
//////////

import frem from "frem"
import sizes from "@frog/source/data/sizes.js"

frem({
    "width": sizes.frame.width,
    "height": sizes.frame.height,
})

const frame = document.getElementById("frame")
frame.style.width = sizes.frame.width + "em"
frame.style.height = sizes.frame.height + "em"

////////////////
// Game Loop //
//////////////

import App from "@frog/source/models/App.js"
import Dev from "@frog/source/utility/Dev.js"

import Canvas from "@frog/source/utility/canvas/index.js"
import ViewModel from "@frog/source/views/Root.view.js"
import Loop from "@frog/source/utility/Loop.js"

Canvas.start({
    "frame": sizes.frame,
    "size": sizes.canvas,
    "defaultAnchor": {
        "x": sizes.defaultAnchor.x,
        "y": sizes.defaultAnchor.y,
    },
    "view": ViewModel,
    "isPixelated": true,
    "domparent": document.getElementById("frame"),
    "preload": require("@frog/source/data/preload.js").default,
})

Loop.start(function(delta) {
    Dev.atStartOfLoop()

    App.update(delta)
    Canvas.render()

    Dev.atEndOfLoop()
})

// ////////////////
// // Analytics //
// //////////////
//
// import "@frog/source/analytics.js"
